'use client';

import { useMemo } from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { groupCartItemsBySeller } from '@/lib/utils/cart';
import { useUserCart } from '../hooks/use-user-cart';
import { CartItem } from './cart-item';
interface CartListProps {
  cartPage?: boolean;
}
export const CartList = ({
  cartPage = false
}: CartListProps) => {
  const {
    data,
    isPending
  } = useUserCart();
  const cartItems = data?.cartItems;
  const groupedCartItems = useMemo(() => groupCartItemsBySeller(cartItems || []), [cartItems]);
  if (isPending && cartPage) {
    return <Skeleton className="w-[44rem] h-80" />;
  }
  if (!cartItems?.length && cartPage) {
    return <div className="flex justify-center">
        <p className="text-sm">
          You don&rsquo;t have any items in your cart right now
        </p>
      </div>;
  }
  return <div className="flex flex-col gap-4 " data-sentry-component="CartList" data-sentry-source-file="cart-list.tsx">
      {Object.keys(groupedCartItems).map((seller, index) => {
      const items = groupedCartItems[seller];
      return <CartItem key={index} seller={seller} items={items} cartPage={cartPage} />;
    })}
    </div>;
};